import { FC, useEffect } from "react";
import { Grid, TextField, Typography } from "@mui/material";
import CustomTextField from '../../FormFields/CustomTextField';

interface PaymentProps {
  selected: any;
  methods:  any;
  isEdit?: boolean;
}

// Payment component
const Payment: FC<PaymentProps> = ({selected, methods, isEdit}) => {

  useEffect(() => {
    const setInitialData = () => {
      console.log('called setInitialData for upi details');
      if(selected) {
        console.log(selected);
        methods.setValue('upiId', selected?.upiId);
        methods.setValue('gPayPhone', selected?.gPayPhone);
      }
    }
    setInitialData();
  }, [selected, isEdit, methods]);

  return (
    <>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>UPI ID</h5>
        <TextField
          placeholder='UPI ID' 
          className='c-text-field' 
          {...methods.register('upiId')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          // disabled={(selected)? true : false}
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.upiId?.message ?? ""}</p>
        {/* <CustomTextField label="UPI ID" name="upiId" variant="standard" required InputProps={{ readOnly: (selected)? true : false }} /> */}
      </Grid>
      <Grid item xs={6} md={6} sm={12} sx={{ pt: '0px' }}>
        <h5 className='c-label'>Registered UPI Phone No</h5>
       <TextField
          placeholder='UPI Phone Number' 
          className='c-text-field' 
          {...methods.register('gPayPhone')}
          variant="standard" 
          sx={{width:'100%'}}
          size='small'
          // disabled={(selected)? true : false}
          InputProps={{
            // shrink: true,
            disableUnderline: true,
            // readOnly: (selected)? true : false
          }}
        />
        <p style={{color: "#c33b3b"}}>{methods.formState.errors.gPayPhone?.message ?? ""}</p>
        {/* <CustomTextField label="GPay Number" name="gPayPhone" variant="standard" required InputProps={{ readOnly: (selected)? true : false }} /> */}
      </Grid>
    </>
  );
};

export default Payment;
